<template>
  <div class="CollaborationCase">
    <div class="cont wow bounceInUp">
      <ul class="dataList">
        <li class="dataItem" v-for="(item, index) in list_data" :key="index" @click="ToRouter(item)">

          <div class="i_img">
            <img :src="item.infoImage" alt="">
          </div>
          <div class="i_main">
            <div class="m_title textslh">
              {{ item.infoName }}
            </div>
            <div class="m_desc" v-html="item.infoContent ">
            </div>
            <div class="btn_more">查看详情>></div>
          </div>

        </li>
      </ul>

      <el-pagination class="pagination" background layout="prev, pager, next"
                     :hide-on-single-page="list_data.length <= PageSize" :page-size="PageSize" :total="Total"
                     @size-change="getPage" @current-change="getPage">
      </el-pagination>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CollaborationCase',
  data () {
    return {
      Total: 1, // 总数
      PageNo: 1, // 当前页
      PageSize: 5, // 每页显示条数
      list_data: [
      ]
    }
  },
  created () {
    this.getInfoManageList()
  },
  methods: {
    ToRouter (data) {
      sessionStorage.jsonData = JSON.stringify(data)
      this.$emit('ToDetails', data)
    },
    getInfoManageList () {
      const that = this
      this.$request.getCollaborationList({
        pageNum: this.PageNo,
        pageSize: this.PageSize,
      }).then((res) => {
        if (res.code === 200) {
          console.log(res)
          that.Total = res.total
          res.rows.map((item) => {
            item.infoImage = this.$store.state.baseUrl + item.infoImage
          })
          that.$set(that, 'list_data', res.rows)
        }
      })
    },
    async getPage (page) {
      // 获取第 page 页数据
      console.log(page)
      this.PageNo = page
      this.getInfoManageList()
    },
  }
}
</script>

<style lang="scss" scoped>
.CollaborationCase {
  position: relative;
  .dataList {
    .dataItem {
      display: flex;
      justify-content: space-between;
      align-items: inherit;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 0 30px;
      margin-bottom: 30px;
      &:last-child {
        margin: 0;
      }

      .i_img {
        flex-shrink: 0;
        width: 292px;
        height: 170px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .i_main {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 20px;
        .m_title {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
        }
        .m_desc {
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          text-align: justify;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
        }
        .btn_more {
          font-weight: 400;
          font-size: 16px;
          color: #406cdd;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>